import React, { useContext } from 'react';
import S from "./ValueEstimatesAndGrowth";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from '../../../Table/index';
import moment from 'moment';

const ValueEstimatesAndGrowth: React.FC<FundSingle> = () => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    var tableValues = {};

    var portfolio = fundRiskDetails.Portfolios[0];
    var benchmarkPortfolio = fundRiskDetails.Benchmark[0].Portfolios[0];
    var portfolioDate = moment(portfolio.Date).format('YYYY-MM-DD');

    tableValues["P/E (Kurs/Vinst)"] = [portfolio.EquityStatistics.ProspectiveEarningsYield.toFixed(2), benchmarkPortfolio.EquityStatistics.ProspectiveEarningsYield.toFixed(2)];
    tableValues["Kurs/eget kapital"] = [portfolio.EquityStatistics.ProspectiveBookValueYield.toFixed(2), benchmarkPortfolio.EquityStatistics.ProspectiveBookValueYield.toFixed(2)];
    tableValues["P/S (Kurs/Försäljning)"] = [portfolio.EquityStatistics.ProspectiveRevenueYield.toFixed(2), benchmarkPortfolio.EquityStatistics.ProspectiveRevenueYield.toFixed(2)];
    tableValues["P/C (kurs/kassaflöde)"] = [portfolio.EquityStatistics.ProspectiveCashFlowYield.toFixed(2), benchmarkPortfolio.EquityStatistics.ProspectiveCashFlowYield.toFixed(2)];
    tableValues["Direktavkastningsfaktor"] = [portfolio.EquityStatistics.ProspectiveDividendYield.toFixed(2), benchmarkPortfolio.EquityStatistics.ProspectiveDividendYield.toFixed(2)];
    tableValues["Långsiktig resultattillväxt"] = [portfolio.EquityStatistics.Forecasted5YearEarningsGrowth.toFixed(2), benchmarkPortfolio.EquityStatistics.Forecasted5YearEarningsGrowth.toFixed(2)];
    tableValues["Historisk resultattillväxt"] = [portfolio.EquityStatistics.ForecastedEarningsGrowth.toFixed(2), benchmarkPortfolio.EquityStatistics.ForecastedEarningsGrowth.toFixed(2)];
    tableValues["Säljtillväxt"] = [portfolio.EquityStatistics.ForecastedRevenueGrowth.toFixed(2), benchmarkPortfolio.EquityStatistics.ForecastedRevenueGrowth.toFixed(2)];
    tableValues["Tillväxt kassaflöde"] = [portfolio.EquityStatistics.ForecastedCashFlowGrowth.toFixed(2), benchmarkPortfolio.EquityStatistics.ForecastedCashFlowGrowth.toFixed(2)];
    tableValues["Tillväxt bokfört värde"] = [portfolio.EquityStatistics.ForecastedBookValueGrowth.toFixed(2), benchmarkPortfolio.EquityStatistics.ForecastedBookValueGrowth.toFixed(2)];

    var tableData = {
        headings: ['', 'FOND', 'KATEGORI'],
        rows: tableValues
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Värderingar och tillväxttakt" subTitle={portfolioDate} />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default ValueEstimatesAndGrowth;
